import type { ErpCountriesWithPriceTypeResponse } from 'com.cogvio.pricemonitor.api';
import { Request } from '~/infrastructure/mam/ApiClient';

export enum ErpCountriesWithPriceTypeError {
	'internal-server-error' = 'internal-server-error',
}

export const getHumanReadableErrorCode = (codes: Set<string>): string | null => {
	return null;
};

export class ErpCountriesWithPriceTypeRequest
	implements Request<ErpCountriesWithPriceTypeResponse, ErpCountriesWithPriceTypeError>
{
	public readonly knownErrorCodes = Object.values(ErpCountriesWithPriceTypeError);
	public readonly path: string;

	public constructor() {
		this.path = `erp/countries`;
	}
}
